import { createPersistentStorage } from '@src/utils/createPersistentStorage'
import { uniqBy } from 'lodash'
import { localStorage } from 'react-storage'

// provides interface to get/set recent search results from localStorage

export type RecentSearchResults = string[]

export const useRecentSearch = (
  cacheVersion: string = 'v1',
  maxCount: number = 4
): {
  getRecentSearch: () => RecentSearchResults
  setRecentSearch: (searchTerm: string) => void
} => {
  const recentSearchesStorage = createPersistentStorage<RecentSearchResults>(
    localStorage,
    'RECENT_SEARCHES',
    cacheVersion
  )

  const getRecentSearch = (): RecentSearchResults =>
    recentSearchesStorage.get() || []

  const setRecentSearch = (searchTerm: string) => {
    recentSearchesStorage.set(
      uniqBy(
        [searchTerm, ...(recentSearchesStorage.get() || [])],
        (term) => term
      ).slice(0, maxCount)
    )
  }

  return {
    getRecentSearch,
    setRecentSearch,
  }
}
